import { redirectToSignIn, AUTH_RESTRICTED_MESSAGE } from "@/lib/auth";
import { Database, SignIn, Warning } from "@phosphor-icons/react";

export default function SignInGate({ reason }) {
    const denied =
        typeof reason === "string" && reason.toLowerCase().includes("authorised");
    return (
        <div className="min-h-screen bg-white bg-grid flex items-center justify-center p-6">
            <div
                className="panel p-10 max-w-md w-full"
                data-testid="sign-in-gate"
                style={{ boxShadow: "8px 8px 0 rgba(0,0,0,0.06)" }}
            >
                <div className="flex items-center gap-3 mb-5">
                    <div className="w-10 h-10 bg-black flex items-center justify-center">
                        <Database size={20} weight="bold" color="#fff" />
                    </div>
                    <div className="flex flex-col leading-tight">
                        <span className="font-display text-xl font-bold tracking-tight">
                            ProvidersCSV
                        </span>
                        <span className="label-kicker" style={{ fontSize: 9 }}>
                            Service Provider Command Center
                        </span>
                    </div>
                </div>
                <h1 className="font-display text-3xl font-bold mb-2 tracking-tight">
                    Sign in to continue
                </h1>
                <p className="text-[#52525b] text-sm mb-6">
                    Access is restricted to approved team members. Sign in with your
                    Google account; if your email is on the allow-list you'll land on the
                    Today dashboard.
                </p>
                {reason && (
                    <div
                        className="mb-5 p-3 border flex items-start gap-2"
                        style={{ borderColor: denied ? "#ff3333" : "#e4e4e7", background: "#fff7e0" }}
                        data-testid="sign-in-error"
                    >
                        <Warning
                            size={16}
                            weight="fill"
                            color={denied ? "#ff3333" : "#b07000"}
                            className="shrink-0 mt-[2px]"
                        />
                        <div className="text-xs text-[#52525b]">
                            {denied ? AUTH_RESTRICTED_MESSAGE : reason}
                        </div>
                    </div>
                )}
                <button
                    type="button"
                    onClick={redirectToSignIn}
                    className="btn-primary w-full justify-center"
                    data-testid="sign-in-button"
                >
                    <SignIn size={16} weight="bold" />
                    Sign in with Google
                </button>
                <p className="mt-6 text-[11px] text-[#a1a1aa] mono">
                    powered by Emergent-managed Google auth
                </p>
            </div>
        </div>
    );
}
